import { log } from 'evlog/client';
import { useTranslation } from 'react-i18next';
import { redirect, useLoaderData } from 'react-router';

import { requiresAuth } from '../../auth-loader.ts';
import { ServicePayment } from '../../components/booking/service-payment.tsx';
import {
  isSecondOpinionReady,
  secondOpinionReservationStore,
} from '../../hooks/reservation/second-opinion.ts';
import { usePaymentInfo } from '../../hooks/use-payment-info.ts';

export default function SecondOpinionPayments() {
  const loaderData = useLoaderData() as Awaited<
    ReturnType<typeof secondOpinionPaymentsLoader>
  >;
  const { t } = useTranslation();
  const payment = usePaymentInfo({
    kind: 'second_opinion',
    urgent: loaderData.reservation.urgent,
    appliedPromo: loaderData.reservation.appliedPromo,
  });
  const amount = payment.amountDue;

  const handleInitiating = async () => {
    log.info({ action: 'payment_initiate', service: 'second_opinion' });
    return true;
  };

  return (
    <ServicePayment
      serviceLabel={t('common.services.secondOpinion')}
      amountLabel={amount.label}
      amountValue={amount.value}
      description={t('booking.paymentDescription')}
      metadata={{ transferables: JSON.stringify(buildMetadata(loaderData)) }}
      onInitiating={handleInitiating}
    />
  );
}

export async function secondOpinionPaymentsLoader() {
  const identity = await requiresAuth();
  const reservation = secondOpinionReservationStore.read();
  if (identity.userType === 'B2B') {
    throw redirect('/');
  }
  if (!reservation || !isSecondOpinionReady(reservation)) {
    throw redirect('/second-opinion');
  }
  return { identity, reservation };
}

function buildMetadata(
  loaderData: Awaited<ReturnType<typeof secondOpinionPaymentsLoader>>,
) {
  const { appliedPromo, ...rest } = loaderData.reservation;
  return {
    ...rest,
    service: 'second_opinion',
    promoCode: appliedPromo?.code,
    uid: loaderData.identity.id,
  };
}
